<zn-hierarchical-view
  [rootComponentInstance]="this"
  [actions]="actions"
/>
<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>